module.exports = __webpack_public_path__ + "static/media/Moldflow Insight Premium.320cd141.png";